export default {
  setBreadcrumbs: ({ commit }, payload) => commit('setBreadcrumbs', payload)
};